import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) =>
	({
		title: {
			alignItems: "center",
			textDecoration: "none",
			"&:hover": {
				textDecoration: "underline",
				cursor: "pointer"
			},
		},
		container: {
			alignItems: "center",
		},
		stats: {
			textAlign: "center",
		},
		stat: {
		},
		actions: {
			textAlign: "right",
			
		},
		actionButtons: {
			// marginLeft: 10,
		},
	} satisfies Record<string, CSSObject>);
